module.exports = __webpack_public_path__ + "static/ROHS-af7e5b2f52b8c2112bf6be9e1a963439.jpg";